module.exports = __webpack_public_path__ + "static/media/2024-02-12_CAN_event,_Dr._Chrissman_CEO_2.54b5eafe.jpg";